import {
    EyeIcon,
    UserIcon,
    EnvelopeIcon,
    PhoneIcon,
    LockClosedIcon,
    LockOpenIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    UsersIcon,
} from '@heroicons/react/24/outline'
import { formatPhone } from '../../../Common'

const getInitials = (nome) => {
    if (!nome) return '?'
    return nome.split(' ').slice(0, 2).map(n => n[0]).join('').toUpperCase()
}

const InvestidoresInvestimentosTable = ({ data = [], loading, viewVinculo, toggleStatus, previous, next, page, recordsPerPage }) => (
    <>
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-100 flex items-center gap-2">
                <div className="p-1.5 bg-gray-900 rounded-lg">
                    <UsersIcon className="w-4 h-4 text-brand-yellow" />
                </div>
                <h2 className="text-sm font-semibold text-gray-900">Investidores Vinculados</h2>
            </div>

            {loading ? (
                <div className="flex flex-col items-center justify-center py-16">
                    <span className="h-8 w-8 rounded-full border-2 border-gray-200 border-t-brand-yellow animate-spin mb-3" />
                    <p className="text-sm text-gray-400">Carregando investidores...</p>
                </div>
            ) : data.length > 0 ? (
                <>
                    {/* Header desktop */}
                    <div className="hidden lg:grid grid-cols-5 gap-2 px-4 py-2 bg-gray-50 border-b border-gray-100 text-xs font-semibold text-gray-500 uppercase tracking-wide">
                        {[
                            [EyeIcon, 'Ações'],
                            [UserIcon, 'Investidor'],
                            [EnvelopeIcon, 'E-mail'],
                            [PhoneIcon, 'Telefone'],
                            [LockOpenIcon, 'Status'],
                        ].map(([Icon, lbl], i) => (
                            <div key={i} className="flex items-center justify-center gap-1">
                                <Icon className="w-3 h-3" />{lbl}
                            </div>
                        ))}
                    </div>

                    <div className="divide-y divide-gray-50">
                        {data.map((item) => (
                            <div key={item.id} className="px-4 py-3 hover:bg-gray-50 transition-colors">
                                {/* Desktop */}
                                <div className="hidden lg:grid grid-cols-5 gap-2 items-center">
                                    <div className="flex items-center justify-center gap-1.5">
                                        <button onClick={() => viewVinculo?.(item)} className="p-1.5 bg-brand-yellow/15 text-gray-900 rounded-lg hover:bg-brand-yellow/30 transition-colors" title="Visualizar">
                                            <EyeIcon className="w-4 h-4" />
                                        </button>
                                        <button
                                            onClick={() => toggleStatus?.(item)}
                                            className={`p-1.5 rounded-lg transition-colors ${item.ativo ? 'bg-green-50 text-green-600 hover:bg-green-100' : 'bg-red-50 text-red-600 hover:bg-red-100'}`}
                                            title={item.ativo ? 'Desativar' : 'Ativar'}
                                        >
                                            {item.ativo ? <LockOpenIcon className="w-4 h-4" /> : <LockClosedIcon className="w-4 h-4" />}
                                        </button>
                                    </div>
                                    <div className="flex items-center gap-2 justify-center">
                                        <div className="w-7 h-7 rounded-lg bg-gray-900 flex items-center justify-center text-brand-yellow text-xs font-bold flex-shrink-0">
                                            {getInitials(item.nome_investidor)}
                                        </div>
                                        <span className="text-xs font-medium text-gray-900 truncate">{item.nome_investidor || '—'}</span>
                                    </div>
                                    <div className="text-center text-xs text-gray-500 truncate">{item.email_investidor}</div>
                                    <div className="text-center text-xs text-gray-500">{formatPhone(item.telefone_investidor)}</div>
                                    <div className="flex justify-center">
                                        <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-lg text-xs font-medium ${item.ativo ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600'}`}>
                                            {item.ativo ? <><LockOpenIcon className="w-3 h-3" />Ativo</> : <><LockClosedIcon className="w-3 h-3" />Inativo</>}
                                        </span>
                                    </div>
                                </div>

                                {/* Mobile */}
                                <div className="lg:hidden space-y-3">
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-2 min-w-0">
                                            <div className="w-9 h-9 rounded-lg bg-gray-900 flex items-center justify-center text-brand-yellow text-xs font-bold flex-shrink-0">
                                                {getInitials(item.nome_investidor)}
                                            </div>
                                            <div className="min-w-0">
                                                <p className="text-sm font-semibold text-gray-900 truncate">{item.nome_investidor || '—'}</p>
                                                <p className="text-xs text-gray-400 truncate">{item.email_investidor}</p>
                                            </div>
                                        </div>
                                        <div className="flex gap-1.5 ml-2 flex-shrink-0">
                                            <button onClick={() => viewVinculo?.(item)} className="p-1.5 bg-brand-yellow/15 text-gray-900 rounded-lg"><EyeIcon className="w-4 h-4" /></button>
                                            <button onClick={() => toggleStatus?.(item)} className={`p-1.5 rounded-lg ${item.ativo ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600'}`}>
                                                {item.ativo ? <LockOpenIcon className="w-4 h-4" /> : <LockClosedIcon className="w-4 h-4" />}
                                            </button>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-2 gap-2">
                                        <div className="bg-gray-50 rounded-lg px-3 py-2">
                                            <p className="text-[10px] font-semibold uppercase tracking-wide text-gray-400 mb-0.5">Telefone</p>
                                            <p className="text-xs font-medium text-gray-700">{formatPhone(item.telefone_investidor)}</p>
                                        </div>
                                        <div className="bg-gray-50 rounded-lg px-3 py-2">
                                            <p className="text-[10px] font-semibold uppercase tracking-wide text-gray-400 mb-0.5">Status</p>
                                            <span className={`inline-flex items-center gap-1 text-xs font-medium ${item.ativo ? 'text-green-600' : 'text-red-600'}`}>
                                                {item.ativo ? <><LockOpenIcon className="w-3 h-3" />Ativo</> : <><LockClosedIcon className="w-3 h-3" />Inativo</>}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            ) : (
                <div className="flex flex-col items-center justify-center py-16 text-center">
                    <div className="w-12 h-12 rounded-2xl bg-gray-900 flex items-center justify-center mb-3">
                        <UsersIcon className="w-6 h-6 text-brand-yellow" />
                    </div>
                    <h3 className="text-sm font-semibold text-gray-900 mb-1">Nenhum investidor vinculado</h3>
                    <p className="text-xs text-gray-400">Vincule investidores a este empreendimento.</p>
                </div>
            )}
        </div>

        {data.length > 0 && (
            <div className="flex items-center justify-between bg-white border border-gray-100 rounded-2xl px-5 py-3 shadow-sm mt-4">
                <span className="text-sm text-gray-500">Página {(page ?? 0) + 1} · {data.length} registros</span>
                <div className="flex gap-2">
                    <button onClick={previous} disabled={page === 0} className="flex items-center gap-1 px-3 py-1.5 text-sm text-gray-600 border border-gray-200 rounded-lg hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
                        <ChevronLeftIcon className="w-4 h-4" /> Anterior
                    </button>
                    <button onClick={next} disabled={data.length < (recordsPerPage ?? 10)} className="flex items-center gap-1 px-3 py-1.5 text-sm text-gray-600 border border-gray-200 rounded-lg hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
                        Próximo <ChevronRightIcon className="w-4 h-4" />
                    </button>
                </div>
            </div>
        )}
    </>
)

export default InvestidoresInvestimentosTable
